import React from 'react'
import contact from "../../img/contact.jpg";
import "./privacyPolicy.scss";

const PrivacyPolicy = () => {

  const sections = [
    { id: "collect", title: "1. Information We Collect" },
    { id: "usage", title: "2. How We Use Information" },
    { id: "sharing", title: "3. Data Sharing" },
    { id: "security", title: "4. Security & Storage" },
    { id: "rights", title: "5. Your Rights" },
    { id: "contact", title: "6. Contact Us" },
  ];
  return (
    <div className="__fw">
      <div
        className="contact_head"
        style={{
          backgroundImage: `url(${contact})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="cn_in">
          <h2>
            Privacy <em>Policy</em>{" "}
          </h2>
        </div>
      </div>

      <div className="__mw">
        <div className="policy_wrp">
          <div className="policy-container">
            {/* Sidebar Navigation */}
            <nav className="policy-sidebar">
              <h4>Contents</h4>
              <ul>
                {sections.map((section) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>{section.title}</a>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Main Content */}
            <main className="policy-content">
              <header className="policy-header">
                <p className="effective-date">
                  Effective Date: <span>01.01.2026</span>
                </p>
              </header>

              <section className="intro-card">
                <p>
                  At <strong>[Your Company Name] FZ-LLC</strong>, registered in
                  Dubai Innovation City Free Zone, we develop and license
                  algorithmic trading software.{" "}
                  <strong>We are not a broker or financial institution.</strong>
                  We do not access or control client funds.
                </p>
              </section>

              <article id="collect">
                <h2>1. Information We Collect</h2>
                <div className="grid-info">
                  <div className="info-block">
                    <h3>Personal Info</h3>
                    <p>
                      Name, email, phone, and billing details provided during
                      registration.
                    </p>
                  </div>
                  <div className="info-block">
                    <h3>Technical Data</h3>
                    <p>
                      IP address, device type, logs, and diagnostic usage
                      statistics.
                    </p>
                  </div>
                </div>
                <p className="note">
                  <strong>Trading Data:</strong> We only collect limited
                  performance info if voluntarily provided for troubleshooting.
                </p>
              </article>

              <article id="usage">
                <h2>2. How We Use Your Information</h2>
                <ul>
                  <li>Maintain access to software and services.</li>
                  <li>Process payments and subscriptions.</li>
                  <li>Comply with UAE laws and Dubai Free Zone regulations.</li>
                  <li>Prevent fraud and unauthorized access.</li>
                </ul>
              </article>

              <article id="sharing">
                <h2>3. Information Sharing</h2>
                <p>We do not sell your data. We share only with:</p>
                <ul>
                  <li>
                    <strong>Service Providers:</strong> Cloud hosting and
                    payment processors.
                  </li>
                  <li>
                    <strong>Legal Authorities:</strong> When required by UAE
                    court orders.
                  </li>
                </ul>
              </article>

              <article id="security">
                <h2>4. Data Storage & Security</h2>
                <p>
                  Your information may be stored on secure servers globally.
                  While we use encryption and access controls, please note that
                  no electronic storage is 100% secure.
                </p>
              </article>

              <article id="rights">
                <h2>5. Your Rights</h2>
                <p>Subject to UAE data protection laws, you may:</p>
                <div className="rights-tags">
                  <span>Access Data</span>
                  <span>Request Correction</span>
                  <span>Request Deletion</span>
                </div>
              </article>

              <article id="contact" className="contact-section">
                <h2>6. Contact Information</h2>
                <div className="contact-card">
                  <p>
                    <strong>[Your Company Name] FZ-LLC</strong>
                  </p>
                  <p>Dubai Innovation City Free Zone, UAE</p>
                  <p>
                    Email:{" "}
                    <a href="mailto:support@yourcompany.com">
                      support@yourcompany.com
                    </a>
                  </p>
                </div>
              </article>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy
